import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl } from '@angular/forms';
import { NextComponentService } from '../../../../../lib/services/next-component.service';
import { IComponentDetails } from '../../../../../../src/lib/interfaces/component-details.interface';
import { StepComponent } from '../stepcomponent.class';
import { ComponentName } from '../../../../../lib/enum/component-name.enum';
import { ComponentGroup } from '../../../../../lib/enum/component-group.enum';
import { CreditAppService } from '../../../../../lib/services/credit-app.service';
import { PreviousComponentService } from '../../../../../lib/services/previous-component.service';
import { IConfig, IDescriptionValuePair } from '../../../../../lib/interfaces/config.interface';
import { LookupMappingInformation, AdditionalInfo } from '../../../../../lib/interfaces/credit-application-config.interface';
import { CreditApplicationConfig } from '../../../../../lib/interfaces/credit-application-config.interface';
import { ReviewInfoComponent } from '../review-info/review-info.component';
import { PersonalInfoComponent } from '../personal-info/personal-info.component';
import { StepType } from '../../../../../lib/enum/step-type.enum';
import { getLookupMappings, validateAllFormFields, getBackButton} from '../../../../utils/utils.functions';
import { NotificationsService } from '../../../../../lib/services/notifications.service';
import { NotificationType, INotification } from '../../../../../lib/interfaces/notification.interface';
import createNumberMask from '../../../../../lib/utils/numberMask.functions';
import { OtherIncomeInformation} from '../../../../interfaces/credit-application.interface';
import { AnalyticsEventService } from '../../../../../lib/services/analytics-event.service';
import { NextCTAClick, ServerError } from '../../../../../lib/actions/analytics.action';
import { IAnalyticsErrorResponse } from '../../../../../lib/interfaces/analytics.interface';
import { UDOConstant, ErrorType } from '../../../../../lib/enum/analytics.enum';

@Component({
  selector: 'dt-additional-info',
  templateUrl: './additional-info.component.html',
  styleUrls: ['./additional-info.component.scss'],
  standalone: false
})
export class AdditionalInfoComponent implements OnInit {
  type: StepType = StepType.Buyer;
  additionalInfoForm: UntypedFormGroup;
  currencyMask: Array<string | RegExp>;
  additionalInfoConfigData: AdditionalInfo;
  creditAppConfigData: CreditApplicationConfig;
  lookupMappingInfo: LookupMappingInformation[];
  incomeFrequencies: IDescriptionValuePair[];
  incomeSources: IDescriptionValuePair[];
  numberMask: any;
  formSubmitted = false;
  isSaving = false;
  isBuyNow = false;
  SubPage = '';
  isLegacyCreditApp:boolean = false;
  // tslint:disable-next-line: variable-name
  private _formSubmitAttempt = false;
  public get formSubmitAttempt(): boolean {
    return this._formSubmitAttempt;
  }
  public set formSubmitAttempt(value: boolean) {
    this._formSubmitAttempt = value;
  }

  constructor(private fb: UntypedFormBuilder,
              @Inject('config') public SitecoreConfig: IConfig,
              private nextComponentService: NextComponentService,
              private creditAppService: CreditAppService,
              private notificationService: NotificationsService,
              private previousComponentService: PreviousComponentService,
              private analyticsEventService: AnalyticsEventService) { }

  public get additionalInfo(): OtherIncomeInformation {
    if (this.creditAppService &&
      this.creditAppService.CreditApplication[this.type] &&
      this.creditAppService.CreditApplication[this.type].financialInformation &&
      this.creditAppService.CreditApplication[this.type].financialInformation.otherIncomeInformation) {
        const otherIncome: OtherIncomeInformation = {
          ...this.creditAppService.CreditApplication[this.type].financialInformation.otherIncomeInformation
        };
        // tslint:disable-next-line: max-line-length
        if (this.incomeFrequencies && otherIncome.amount !== null &&
          !this.incomeFrequencies.some(v => v.Value === otherIncome.frequency)) {
          otherIncome.frequency = '';
        }
        if (otherIncome.amount) {
          otherIncome.amount = otherIncome.amount.toString();
        }
        return otherIncome;
      }
    return {
      amount: null,
      frequency: null,
      otherIncomeType: ''
    };
  }

  public get hasCoBuyer(): string {
    if (this.creditAppService &&
      this.creditAppService.CreditApplication.coBuyer) {
      return 'Yes';
    }
    return 'No';
  }

  ngOnInit() {
    if (
      this.SitecoreConfig &&
      this.SitecoreConfig.Sitecore &&
      this.SitecoreConfig.Sitecore.CreditApplicationConfig
    ) {
      this.isBuyNow = this.SitecoreConfig.Sitecore.isBuyNow;
      this.additionalInfoConfigData = this.SitecoreConfig.Sitecore.CreditApplicationConfig.AdditionalInfo;
      this.creditAppConfigData = this.SitecoreConfig.Sitecore.CreditApplicationConfig;
      this.lookupMappingInfo = this.SitecoreConfig.Sitecore.LookupMappingInformation;
      this.SubPage = this.SitecoreConfig.Sitecore.SubPage ? this.SitecoreConfig.Sitecore.SubPage : '';
      this.isLegacyCreditApp = this.SitecoreConfig.Sitecore.isLegacyCreditApp;
      if(this.isLegacyCreditApp){
        this.updateCtas();
      }

    }

    this.incomeFrequencies = getLookupMappings(this.lookupMappingInfo, 'IncomePeriodIntervalType');
    this.incomeSources = getLookupMappings(this.lookupMappingInfo, 'IncomeSourceType');

    this.additionalInfoForm = this.fb.group({
      AdditionalIncome: [this.getAmount(this.additionalInfo.amount) , [Validators.min(1)]],
      // IncomeFrequency: [this.additionalInfo.frequency],
      IncomeSource: [this.additionalInfo.otherIncomeType],
      CoBuyer: [this.hasCoBuyer, [Validators.required]]
    });

    // const IncomeFrequency = this.additionalInfoForm.get('IncomeFrequency');
    const IncomeSource = this.additionalInfoForm.get('IncomeSource');
 
    this.additionalInfoForm.get('AdditionalIncome').valueChanges
      .subscribe(value => {
        if (value) {
          // IncomeFrequency.setValidators([Validators.required]);
          IncomeSource.setValidators([Validators.required]);
          
        } else {
          // IncomeFrequency.setValidators([]);
          IncomeSource.setValidators([]);
         
          IncomeSource.reset('');
          // IncomeFrequency.reset('');
        }

        // IncomeFrequency.updateValueAndValidity();
        IncomeSource.updateValueAndValidity();
      });

    this.numberMask = createNumberMask({
      prefix: ''
    });

    if (this.additionalInfoForm.valid && this.additionalInfo.amount !== null) {
      this.formSubmitted = true;
    }

    validateAllFormFields(this.additionalInfoForm);

    if (this.type === StepType.CoBuyer) {
      this.notificationService.notificationBroadcasted$.subscribe((n: INotification) => {
        if (n !== null && n.Type === NotificationType.coBuyerDeactivation) {
          this.additionalInfoForm.markAsDirty();
        }
      });
    }

  }

  getAmount(amount) {
   return amount === 0 ? '' : amount;
  }
  isCoBuyerEnabled() {
    return this.additionalInfoForm.get('CoBuyer').value === 'Yes';
  }

  activateRadio(el) {
    document.getElementById(el.currentTarget.getAttribute('for')).click();
  }

  goNext() {
    let ca:any;
    this.formSubmitAttempt = true;
    let nextComponent: IComponentDetails;
    getBackButton();
    if ((this.additionalInfoForm.valid && this.additionalInfoForm.dirty)
    || (this.additionalInfoForm.valid && !this.formSubmitted)) {
      if (this.type === StepType.Buyer) {
        if (this.isCoBuyerEnabled()) {
          this.notificationService.broadcastNotification({
            Message: 'Buyer has used Summoning Jutsu for Co-Buyer', Type: NotificationType.coBuyerActivation
          });
        } else {
          this.notificationService.broadcastNotification({
            Message: 'Buyer has reversed Summoning Jutsu for Co-Buyer', Type: NotificationType.coBuyerDeactivation
          });
        }
      }

      if (this.SitecoreConfig?.Sitecore?.isLegacyCreditApp) {
        ca = { ...this.creditAppService.LegacyCreditApplication };
      }else{
        ca = { ...this.creditAppService.CreditApplication };
      }

      const stepCount = (this.type === StepType.Buyer ? 6 : 12);
      ca.step = stepCount;

      const additionalIncome = this.additionalInfoForm.get('AdditionalIncome').value ?
      this.additionalInfoForm.get('AdditionalIncome').value.replace(/,\s?/g, '').replace(/\b(0(?!\b))+/g, '') : '';

      if (ca[this.type]) {
        ca[this.type].financialInformation.otherIncomeInformation = {
          // frequency: additionalIncome ? this.additionalInfoForm.get('IncomeFrequency').value : '',
          amount: additionalIncome,
          otherIncomeType: additionalIncome ? this.additionalInfoForm.get('IncomeSource').value : ''
        };
      }

      if (this.SitecoreConfig?.Sitecore?.isLegacyCreditApp) {
        if(additionalIncome){
          ca[this.type].financialInformation.otherIncomeInformation = {
            amount: additionalIncome ? additionalIncome : 0 ,
            otherIncome: additionalIncome ? this.additionalInfoForm.get('IncomeSource').value : '',
            explain: "",
          };
        }else{
          ca[this.type].financialInformation.otherIncomeInformation = null;
        }
        
      }


      if (this.type === StepType.Buyer && this.isCoBuyerEnabled()) {
        if (!ca.coBuyer && !this.SitecoreConfig.Sitecore.isLegacyCreditApp) {
          ca.coBuyer = {
            personalInformation: {
              currentAddress: {
                addressLine1: null,
                addressLine2: null,
                city: null,
                monthsAtAddress: 0,
                postalCode: null,
                stateCode: null,
                yearsAtAddress: 0
              },
              emailAddress: null,
              firstName: null,
              lastName: null,
              middleName: null,
              phoneNumber: null,
              preQualAmount: 0,
              previousAddress: [],
              sameAddresAsApplicant: false
            },
            authorizationConsent: false,
            consentIndicator: false,
            educationalInformation: null,
            financialInformation: {
              currentEmployer: null,
              hasOtherIncome: false,
              otherIncomeInformation: null,
              previousEmployer: null,
              residenceInformation: {
                monthlyMortgageAmount: null,
                monthsAtAddress: null,
                mortgageCompany: null,
                residenceType: null,
                yearsAtAddress: null
              },
              securityInformation: {
                dob: null,
                ssn: null,
                ssn1: null,
                ssn2: null,
                ssn3: null
              }
            },
            initials: '',
            relationshipToApplicant: null
          };
          ca.hasCoBuyer = true;
        }
        else if(this.SitecoreConfig.Sitecore.isLegacyCreditApp){
          ca.coBuyer= {
            personalInformation: {
              firstName: "",
              lastName: "",
              middleName: "",
              phoneNumber: "",
              emailAddress: "",
              currentAddress: {
                addressLine1: "",
                addressLine2: "",
                city: "",
                state: "",
                stateCode: "",
                postalCode: "",
                yearsAtAddress: 0,
                monthsAtAddress: 0
              },
              previousAddress: null
            },
            financialInformation: {
              securityInformation: {
                dob: "",
                ssn: ""
              },
              residenceInformation: {
                monthlyMortgageAmount: 0,
                residence: 0
              },
              currentEmployer: {
                employerName: "",
                jobTitle: "",
                salary: 0,
                phoneNumber: "",
                employmentStatus: 0,
                job: 0,
                frequency: 0,
                yearsAtEmployer: 0,
                monthsAtEmployer: 0
              },
              previousEmployer: null,
              otherIncomeInformation: {
                otherIncome: "",
                frequency: 0,
                explain: "",
                amount: 0
              }
            },
            educationalInformation: {
              level: 0
            },
            consentIndicator: false,
            relationshipToApplicant: 0,
            initials: ""
          }
        }

       

        nextComponent = {
          groupName: ComponentGroup.CoBuyerPersonal,
          component: new StepComponent(PersonalInfoComponent, ComponentName.CoBuyerPersonalInfoComponent,
            ComponentGroup.CoBuyerPersonal, true, StepType.CoBuyer),
          componentName: ComponentName.CoBuyerPersonalInfoComponent
        };
      } else {
        if (this.type === StepType.Buyer && !this.isCoBuyerEnabled()) {
          ca.coBuyer = null;
          ca.hasCoBuyer = false;
          delete ca.coBuyer;
        }
        this.notificationService.broadcastNotification({
          Message: 'Review page will be loaded',
          Type: NotificationType.reviewTriggered
        });
        nextComponent = {
          groupName: ComponentGroup.ReviewInfo,
          component: new StepComponent(ReviewInfoComponent, ComponentName.ReviewInfoComponent,
            ComponentGroup.ReviewInfo, true, StepType.Buyer),
          componentName: ComponentName.ReviewInfoComponent
        };
      }

      this.isSaving = true;
      const nextSub = this.creditAppService.SaveCreditApp(ca,this.SubPage);
      nextSub.subscribe(response => {
        if (response.isSuccess) {
          this.isSaving = false;
          this.formSubmitted = true;
          this.additionalInfoForm.markAsPristine();
          if (this.type === StepType.Buyer) {
            this.analyticsEventService.reportAnalyticsEvent(
              new NextCTAClick(new StepComponent(AdditionalInfoComponent,
                          ComponentName.AdditionalInfoComponent,
                          ComponentGroup.AdditionalInfo, true, this.type))
            );
          } else {
            this.analyticsEventService.reportAnalyticsEvent(
              new NextCTAClick(new StepComponent(AdditionalInfoComponent,
                          ComponentName.CoBuyerAdditionalInfoComponent,
                          ComponentGroup.CoBuyerAdditional, true, this.type))
            );
          }
          this.nextComponentService.loadComponent(nextComponent);
        } else {
          this.isSaving = false;
          this.reportErrorResponse(response);
        }
      }, error => {
        this.isSaving = false;
        this.reportErrorResponse(error);
      });
      return nextSub;
    } else {
      /* istanbul ignore else */
      if (this.additionalInfoForm.valid && this.formSubmitted && this.additionalInfoForm.pristine) {
        if (this.type === StepType.Buyer && this.isCoBuyerEnabled()) {
          nextComponent = {
            groupName: ComponentGroup.CoBuyerPersonal,
            component: new StepComponent(PersonalInfoComponent, ComponentName.CoBuyerPersonalInfoComponent,
              ComponentGroup.CoBuyerPersonal, true, StepType.CoBuyer),
            componentName: ComponentName.CoBuyerPersonalInfoComponent
          };
        } else {

          this.notificationService.broadcastNotification({
            Message: 'Review page will be loaded',
            Type: NotificationType.reviewTriggered
          });
          nextComponent = {
            groupName: ComponentGroup.ReviewInfo,
            component: new StepComponent(ReviewInfoComponent, ComponentName.ReviewInfoComponent,
              ComponentGroup.ReviewInfo, true, StepType.Buyer),
            componentName: ComponentName.ReviewInfoComponent
          };
        }

        this.nextComponentService.loadComponent(nextComponent);
      }
    }
  }

  reportErrorResponse(errorData: any) {
    const analyticsErrorResponse: IAnalyticsErrorResponse = {
      error: errorData.statusCode ? errorData.statusCode : UDOConstant.ErrorCode,
      error_message: errorData.message ? errorData.message : UDOConstant.ServiceUnavailable,
      error_type: ErrorType.CreditAppNotSaved
    };
    this.analyticsEventService.reportAnalyticsEvent(
          new ServerError(new StepComponent(AdditionalInfoComponent,
                                            ComponentName.AdditionalInfoComponent,
                                            ComponentGroup.AdditionalInfo, true, this.type),
                                            analyticsErrorResponse));
  }

  goBack() {
    let currentComponent: IComponentDetails;
    if (this.type === StepType.Buyer) {
      currentComponent = {
        groupName: ComponentGroup.AdditionalInfo,
        component: new StepComponent(AdditionalInfoComponent, ComponentName.AdditionalInfoComponent, ComponentGroup.AdditionalInfo, true),
        componentName: ComponentName.EmploymentInfoComponent
      };
    } else {
      currentComponent = {
        groupName: ComponentGroup.CoBuyerAdditional,
        component: new StepComponent(AdditionalInfoComponent, ComponentName.CoBuyerAdditionalInfoComponent,
          ComponentGroup.CoBuyerAdditional, true, StepType.CoBuyer),
        componentName: ComponentName.CoBuyerAdditionalInfoComponent
      };
    }

    this.previousComponentService.loadComponent(currentComponent);
  }

  clearValidations(formControl: AbstractControl) {
    console.log('clearValidations Hit before');
    if (formControl.invalid) {
      console.log('clearValidations Hit after');
      formControl.reset('');
      this.controlCleared(formControl);
      this.formSubmitAttempt = false;
    }
  }

  hasFocus(element: any) {
    return document.activeElement === element || element.isBlur;
  }

  controlCleared(formControl) {
    switch (this.getControlName(formControl)) {
      default:
        console.log('controlCleared Hit');
        break;
    }
  }

  getControlName(c: AbstractControl): string | null {
    const formGroup = c.parent && c.parent.controls;
    return formGroup ? Object.keys(formGroup).find(name => c === formGroup[name]) : null;
  }

  updateCtas() {
    try {
      (window as any).standalonePrequal.updateCtasPosition();
    } catch (error) {/* istanbul ignore next */
      console.log(error);
    }
  }

}
